import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

export const PageTracking = () => {

    const location = useLocation()

    useEffect(() => {
        // Create a script element to load the gtag.js script
        if (process.env.REACT_APP_ENV === "prod") {
            // Setup dataLayer and gtag function FIRST (like Google's second script)
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };

            // Call gtag functions (they'll be queued until script loads)
            window.gtag('js', new Date());
            window.gtag('config', 'G-YPRQLHFQWZ');

            // Load the script (like Google's first script)
            const script = document.createElement('script');
            script.src = `https://www.googletagmanager.com/gtag/js?id=G-YPRQLHFQWZ`;
            script.async = true;
            document.head.appendChild(script);
        }
        // eslint-disable-next-line
    }, [])

    const pageTitleForPath = (path: string): string => {
        if (path.includes("my_prices")) return "my_prices"
        if (path.includes("dashboard")) return "dashboard"
        if (path.includes("suppliers")) return "suppliers"
        if (path.includes("statement")) return "statement"
        if (path.includes("today_delivery")) return "today_delivery"
        if (path.includes("purchases")) return "purchases"
        if (path.includes("company_detail")) return "company_detail"
        if (path.includes("companies")) return "companies"
        if (path.includes("contract_detail")) return "contract_detail"
        if (path.includes("contracts")) return "contracts"
        if (path.includes("traceability")) return "traceability"
        if (path.includes("company_profil")) return "company_profil"
        if (path.includes("profile")) return "profile"
        if (path.includes("admin")) return "admin"
    }

    useEffect(() => {
        if (process.env.REACT_APP_ENV === "prod" && window.gtag) {
            window.gtag('event', 'page_view', {
                page_path: location.pathname + location.search,
                page_title: pageTitleForPath(location.pathname),
                page_location: window.location.href
            });
        }
    }, [location]);

    return <></>
};